import { Auth } from 'aws-amplify';
import { useProject } from '../config/ProjectContext';
import getCurrentAuthenticatedUserId from '../utils/getCurrentAuthenticatedUserId';

const replaceAt = (str, symbol) => {
  // Handle null/undefined strings and replace first '@' with symbol
  return str ? str.replace('@', symbol) : str;
}


const useAnalytics = () => {
  const { project } = useProject();
  const setAnalytics = async ({ event, sectionId, extraParams }) => {
    try {
      if (!window.dataLayer) {
        window.dataLayer = [];
      }
      const authUser = await Auth.currentAuthenticatedUser();
      const userIdentifier = await getCurrentAuthenticatedUserId();
      const analyticsData = {
        event,
        selected_project: String(project?.code),
        user_email: userIdentifier,
        user_account_id: replaceAt(userIdentifier, '_') || authUser?.attributes?.sub || replaceAt(authUser?.attributes?.id, '_'),
        user_id: authUser?.attributes?.sub || replaceAt(userIdentifier, '_'),
        ...extraParams,
        section_id: sectionId,
      };

      window.dataLayer.push(analyticsData);
      // console.log('Analytics data pushed:', analyticsData);
    } catch (error) {
      console.error('Error setting analytics:', error);
    }
  };

  return { setAnalytics };
};

export default useAnalytics;
